import { render, staticRenderFns } from "./PrismViz.vue?vue&type=template&id=44f7a424&scoped=true"
import script from "./PrismViz.vue?vue&type=script&lang=js"
export * from "./PrismViz.vue?vue&type=script&lang=js"
import style0 from "./PrismViz.vue?vue&type=style&index=0&id=44f7a424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f7a424",
  null
  
)

export default component.exports